import { alpha, lighten } from '@mui/material';

import { COLOR_PALETTE } from 'constants/ui';

import { ROLE_TYPES } from './RoleTag.constants';

const INTERNAL_ROLE_COLOR = '#4D627B';
const DARK_BACKGROUND_ALPHA = 0.2;
const DARK_TEXT_LIGHTEN = 0.4;

export const roleTagColor = {
  [ROLE_TYPES.BORROWER]: {
    backgroundColor: COLOR_PALETTE.ADDITIONAL[1],
    color: COLOR_PALETTE.ADDITIONAL[2],
  },
  [ROLE_TYPES.NON_BORROWER]: {
    backgroundColor: COLOR_PALETTE.PURPLE[2],
    color: COLOR_PALETTE.PURPLE[7],
  },
  [ROLE_TYPES.INTERNAL]: {
    backgroundColor: ({ palette }) => palette.background.hoverDefault,
    color: INTERNAL_ROLE_COLOR,
  },
};

// The light role-tag fills are pale tints that leak near-white on dark; derive a hue-preserving dark
// recipe from each role's saturated text color (low-alpha tint fill + lightened readable text).
const DARK_ROLE_TEXT_COLOR = {
  [ROLE_TYPES.BORROWER]: COLOR_PALETTE.ADDITIONAL[2],
  [ROLE_TYPES.NON_BORROWER]: COLOR_PALETTE.PURPLE[7],
  [ROLE_TYPES.INTERNAL]: INTERNAL_ROLE_COLOR,
};

export const tagStyles = roleType => ({
  borderRadius: '8px',
  padding: '0px 8px',
  lineHeight: '20px',
  fontWeight: 400,
  fontSize: '12px',
  width: 'fit-content',
  backgroundColor: ({ palette }) =>
    palette.mode === 'dark'
      ? alpha(DARK_ROLE_TEXT_COLOR[roleType], DARK_BACKGROUND_ALPHA)
      : roleTagColor[roleType].backgroundColor,
  color: ({ palette }) =>
    palette.mode === 'dark'
      ? lighten(DARK_ROLE_TEXT_COLOR[roleType], DARK_TEXT_LIGHTEN)
      : roleTagColor[roleType].color,
});
